import { useState } from "react";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useAuthPatient from "src/Patient/hooks/useAuthPatient";
import useSavePatient from "src/Patient/hooks/useSavePatient";
import {
  errorsReservationGuestState,
  valuesFormRegisterState,
  valuesFormReservationGuestState,
} from "src/Patient/state/atoms";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { snackbarState } from "src/store/global/snackbarState";
import { hourSelectedState } from "src/store/reservation/reservationState";
import { userState } from "src/store/user/userState";
import { ReservationSchema } from "src/Reservation/schemas/ReservationSchema";
import { activeTabReservationState } from "src/Reservation/state/atoms";
import {
  errorsWaitListState,
  fechaFinWaitListState,
  fechaIniWaitListState,
  professionalWaitListState,
  resumeWaitListState,
  specialityWaitListState,
} from "../state/atoms";
import { ServiceWaitList } from "src/services/agenda/waitlist";
import EmailService from "src/services/email/email";
import template from "src/shared/templates/email-waitlist.txt";
import { WaitListSchema } from "../schemas/WaitListSchema";
import { useNavigate } from "react-router-dom";

export const useWaitList = () => {
  const { catchErrorApi } = useCatchErrorApi();
  const [loadingSaved, setLoadingSaved] = useState(false);
  const [hourSelected, setHourSelected] = useRecoilState(hourSelectedState);
  const setSnackbar = useSetRecoilState(snackbarState);
  const activeTabReservation = useRecoilValue(activeTabReservationState);
  const setErrorsReservationGuest = useSetRecoilState(
    errorsReservationGuestState
  );

  const setErrorWaitList = useSetRecoilState(errorsWaitListState);

  const [valuesFormReservationGuest, setValuesFormReservationGuest] =
    useRecoilState(valuesFormReservationGuestState);
  const valuesFormRegister = useRecoilValue(valuesFormRegisterState);
  const user = useRecoilValue(userState);
  const { handleLoginUser } = useAuthPatient();
  const { handleValidatePhones } = useSavePatient();

  const specialityWaitList = useRecoilValue(specialityWaitListState);
  const professionalWaitList = useRecoilValue(professionalWaitListState);

  const fechaIniValue = useRecoilValue(fechaIniWaitListState);
  const fechaFinValue = useRecoilValue(fechaFinWaitListState);

  const resetSpecialityWaitList = useResetRecoilState(specialityWaitListState);
  const resetProfessionalWaitList = useResetRecoilState(
    professionalWaitListState
  );
  const resetFechaIniWaitList = useResetRecoilState(fechaIniWaitListState);
  const resetFechaFinWaitList = useResetRecoilState(fechaFinWaitListState);
  const valuesFormReservationt = useResetRecoilState(
    valuesFormReservationGuestState
  );
  const navigate = useNavigate();

  const setResumeWaitList = useSetRecoilState(resumeWaitListState);

  const datesErrors = () => {
    let flag = false;
    if (
      fechaIniValue === "" ||
      fechaIniValue === null ||
      fechaIniValue === undefined
    ) {
      setErrorWaitList((currentState) => ({
        ...currentState,
        fechaIni: ["Fecha de inicio es requerida"],
      }));
      flag = true;
    }

    if (
      fechaFinValue === "" ||
      fechaFinValue === null ||
      fechaFinValue === undefined
    ) {
      setErrorWaitList((currentState) => ({
        ...currentState,
        fechaFin: ["Fecha de término es requerida"],
      }));
      flag = true;
    }

    if (
      specialityWaitList.code === null ||
      specialityWaitList.code === undefined ||
      specialityWaitList.code === ""
    ) {
      setErrorWaitList((currentState) => ({
        ...currentState,
        speciality: ["Especialidad es requerida"],
      }));
      flag = true;
    }

    return flag;
  };

  const handleClickSaveWaitList = async () => {
    setLoadingSaved(true);

    let restPropertiesReservation = {};
    let userStorage = user.payload || null;
    let findErrors = false;
    try {
      let dataForReservation = {
        ptdRut: hourSelected?.professional?.ptdRut || professionalWaitList.code,
        agpCorrel:
          hourSelected?.hourSelected?.agpCorrel ||
          professionalWaitList.agp_correl,
        ageCorrel: hourSelected?.hourSelected?.ageCorrel,
        cmnCodigo: hourSelected?.hourSelected?.cmnCodigo,
        espCodigo: hourSelected?.speciality?.code || specialityWaitList.code,
        ageOrigen: "W",
      };

      if (activeTabReservation === "1" && !user.isAuthenticated) {
        const userLogin = await handleLoginUser();
        userStorage = { ...userLogin };
      }

      if (activeTabReservation === "2" && !user.isAuthenticated) {
        const waitListSchema = new WaitListSchema();
        const bodyValidate = await waitListSchema.isValidSchema({
          ...valuesFormReservationGuest,
          isaCodigo: valuesFormRegister["isaCodigo"],
        });
        const emailErrors =
          valuesFormReservationGuest.ageEmail !==
          valuesFormReservationGuest.ageEmailConfirm;
        findErrors =
          (await handleValidatePhones()) || emailErrors || datesErrors();

        if (bodyValidate.ok === false || findErrors) {
          findErrors = true;
          setErrorsReservationGuest((currentState) => ({
            ...currentState,
            ...bodyValidate.dataErrors,
            ageEmailConfirm: emailErrors
              ? ["El correo electrónico no coincide"]
              : [],
          }));
        }

        if (findErrors) return;
        restPropertiesReservation = {
          ...valuesFormReservationGuest,
          usuFono: valuesFormRegister["uswFonoFijo1"],
          usuCelular: valuesFormRegister["uswFonoMovil"],
          isaCodigo: valuesFormRegister["isaCodigo"],
          isaCodigoImed: valuesFormRegister["isaCodigoImed"],
        };
      }

      if (datesErrors()) return;

      if (userStorage) {
        restPropertiesReservation = {
          uprRut: userStorage.uswRut,
          usuNombres: userStorage.uswNombres,
          usuApePat: userStorage.uswApePat,
          usuApeMat:
            userStorage.uswApeMat === "" || !userStorage.uswApeMat
              ? null
              : userStorage.uswApeMat,
          usuCelular: userStorage.uswFonoMovil,
          usuFono: userStorage.usuFonoCompleto,
          ageEmail: userStorage.uswEmail,
          fechaNac: userStorage.fechaNac
            ? userStorage.fechaNac.split(" ")[0].split("-").reverse().join("-")
            : null,
          isaCodigo: userStorage.isaCodigo,
          isaCodigoImed: userStorage.isaCodigoImed,
        };
      }

      dataForReservation = {
        ...dataForReservation,
        ...restPropertiesReservation,
      };

      const objWaitList = {
        EspCodigo: specialityWaitList?.code?.toString() || null,
        PtdRut: professionalWaitList.code || null,
        AgpCorrel:
          hourSelected?.hourSelected?.agpCorrel?.toString() ||
          professionalWaitList.agp_correl?.toString() ||
          null, // para que sirve o es necesario el agp correl lisa espera
        Rut: dataForReservation.uprRut
          ? dataForReservation.uprRut.replace(/[.-]/g, "") // Elimina puntos y guiones
          : null,
        Nombres: dataForReservation.usuNombres,
        ApePat: dataForReservation.usuApePat,
        ApeMat: dataForReservation.usuApeMat,
        Celular: dataForReservation.usuCelular,
        Fono: dataForReservation.usuFono,
        Email: dataForReservation.ageEmail,
        FechaNac: dataForReservation.fechaNac,
        isaCodigo: dataForReservation.isaCodigo?.toString(),
        Origen: "W",
        FechaIni: fechaIniValue,
        FechaFin: fechaFinValue,
      };

      await ServiceWaitList.saveWaitList(objWaitList);
      setSnackbar({
        openAlert: true,
        text: "Se ha registrado en la lista de espera",
        position: {
          vertical: "bottom",
          horizontal: "right",
        },
      });

      const htmlFetch = await fetch(template);
      const html = await htmlFetch.text();

      const replacements = {
        full_name: `${dataForReservation.usuNombres} ${dataForReservation.usuApePat} ${dataForReservation.usuApeMat}`,
        especialista: `${professionalWaitList?.value}`,
        especialidad: `${specialityWaitList?.value}`,
      };

      const htmlBody = replaceTemplatePlaceholders(html, replacements);

      const emailContent = {
        to: dataForReservation.ageEmail,
        subject: "Lista de Espera - Andes Salud",
        body: htmlBody,
      };

      EmailService.send({
        ...emailContent,
      });

      setResumeWaitList({
        ...objWaitList,
        especialidad: specialityWaitList?.value,
        especialista: professionalWaitList?.value,
      });

      resetSpecialityWaitList();
      resetProfessionalWaitList();
      resetFechaIniWaitList();
      resetFechaFinWaitList();
      valuesFormReservationt();
      

      // setHourSelected((currentState) => ({
      //   ...currentState,
      //   emailPaciente: dataForReservation.ageEmail,
      // }));

      navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/inscripcion-exitosa`);

      return true;
    } catch (error) {
      catchErrorApi(error);
    } finally {
      //setShowModalWaitList(false);
      setLoadingSaved(false);
    }
  };

  function replaceTemplatePlaceholders(template, values) {
    let result = template;
    Object.keys(values).forEach((key) => {
      const placeholder = new RegExp(`\\$\\{${key}\\}`, "g");
      result = result.replace(placeholder, values[key]);
    });
    return result;
  }

  return {
    handleClickSaveWaitList,
    loadingSaved,
    setLoadingSaved,
    hourSelected,
    setHourSelected,
    activeTabReservation,
    setErrorsReservationGuest,
    valuesFormReservationGuest,
    setValuesFormReservationGuest,
  };
};
